import { TextSkeleton } from '../Skeleton';

export function PaginationSkeleton() {
    return (
        <div className="flex w-full justify-between">
            <TextSkeleton className="py-2">1 - 5 of 45 items</TextSkeleton>

            <TextSkeleton className="py-2">Next</TextSkeleton>
        </div>
    );
}
